import "./modal.scss";

import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";

const ModalHeading = props => (
  <div className="modalHeading">
    <span className="modalTitle">
      {props.icon ? <Icon className={props.icon} icon={props.icon} color={props.iconColor} /> : null}
      {props.title}
    </span>
    {props.showCancel ? (
      <div className="modalCloseIcon" onClick={props.onCancelClick}>
        <svg className="closeIcon mono">
          <use xlinkHref={"#interfaceClose"} />
        </svg>
      </div>
    ) : null}
  </div>
);

ModalHeading.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  showCancel: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func
};

export default ModalHeading;
